import { render, staticRenderFns } from "./PartnerSso.vue?vue&type=template&id=03f0ce02&scoped=true"
import script from "./PartnerSso.vue?vue&type=script&lang=js"
export * from "./PartnerSso.vue?vue&type=script&lang=js"
import style0 from "./PartnerSso.vue?vue&type=style&index=0&id=03f0ce02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f0ce02",
  null
  
)

export default component.exports